<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div id="topCategoriesSettings" class="gridItemSettingsPanelCustomSettingsBottomItem"
         cvModuleCxoneCustomSettingSection [moduleManager]="moduleManager" after="emp">
        <div class="custom-setting-section-title mt-3">
            <button type="button" class="cxone-btn btn-big btn-secondary" cvLocalizedText langSection="Top_Categories_Module" langKey="Select_Categories" (click)="showCategoriesModal()">Select Categories</button>
        </div>
        <div class="custom-setting-section-body">
            <span><span cvLocalizedText langSection="Top_Categories_Module" langKey="Selected_Categories">Selected categories </span> {{selectedCategories.length}}</span>
        </div>
    </div>
</ng-container>
